import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Award, Check, Layers, Mic } from 'lucide-react';
import { productPillars } from '../../data/mock';
import useReveal from '../../hooks/useReveal';

const ICONS = { Layers, Mic, Award };

/**
 * The three things Tenses actually sells: practice, interview rehearsal, and a
 * certified score. Presented as one tall feature card per pillar so each gets
 * room to make its own argument.
 */
const PillarsSection = () => {
  const ref = useReveal({ stagger: 110 });

  return (
    <section className="section-alt">
      <div ref={ref} className="section">
        <header className="section-header">
          <p className="eyebrow reveal">The platform</p>
          <h2 className="heading-2 reveal mt-3">
            Learn it, rehearse it, then prove it
          </h2>
          <p className="body-large reveal">
            Most tools stop at practice. Tenses takes you all the way to a result you can
            show someone.
          </p>
        </header>

        <div className="grid gap-6 md:grid-cols-3">
          {productPillars.map((pillar) => {
            const Icon = ICONS[pillar.icon] ?? Layers;
            return (
              <article
                key={pillar.id}
                className="module-card reveal flex flex-col"
                style={{
                  '--card-accent': pillar.accent,
                  '--card-wash': `${pillar.accent}18`
                }}
              >
                <span className="module-icon">
                  <Icon className="h-5 w-5" />
                </span>

                <p
                  className="text-[0.7rem] font-semibold uppercase tracking-[0.14em]"
                  style={{ color: pillar.accent }}
                >
                  {pillar.eyebrow}
                </p>
                <h3 className="heading-3 mt-1.5">{pillar.title}</h3>
                <p className="body-medium mt-3 text-[0.95rem]">{pillar.description}</p>

                <ul className="mt-5 space-y-2.5 border-t pt-5" style={{ borderColor: 'var(--border-light)' }}>
                  {pillar.points.map((point) => (
                    <li key={point} className="flex gap-2.5 text-[0.9rem]" style={{ color: 'var(--text-body)' }}>
                      <Check
                        className="mt-0.5 h-4 w-4 shrink-0"
                        style={{ color: pillar.accent }}
                      />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>

        <div className="reveal mt-10 text-center">
          <Link to="/activities" className="btn-ghost">
            Explore all 11 modules
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PillarsSection;
